<template>
<div>
    <b-modal id="employeeAddressFormModal" centered size="lg" no-close-on-backdrop ref="employeeAddressFormModal" :title=" $t('employeeAddress.info')" :cancel-title=" $t('others.cancel_title')" :ok-title=" $t('others.ok_title')" cancel-variant="outline-secondary" @ok.prevent="addOrUpdate">
        <validation-observer ref="simpleRules">
            <b-row>
                <!-- <b-col>
                    <b-form>
                        <validation-provider :name=" $t('employeeAddress.type')" :rules="{ excluded:0}" v-slot="{ errors }">
                            <label for="employee-address-type-input">{{ $t('employeeAddress.type') }}</label>
                            <b-form-select disabled :state="errors.length > 0 ? false:null" v-model="addressTypeSelect" value-field="id" text-field="name" :options="addressTypeOption" />
                            <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </b-form>
                </b-col> -->
                <b-col>
                    <b-form>
                        <validation-provider :name=" $t('employeeAddress.country')" :rules="{ excluded:0}" v-slot="{ errors }">
                            <label for="country-input">{{ $t('employeeAddress.country') }}</label>
                            <b-form-select :state="errors.length > 0 ? false:null" v-model="countrySelect" value-field="id" text-field="name" :options="countryOption" />
                            <small class="text-danger">{{ errors[0] }}</small>

                        </validation-provider>
                    </b-form>
                </b-col>

            </b-row>

            <b-row>
                <b-col>
                    <label class="mt-2" for="employee-address-input">{{ $t('employeeAddress.address') }}</label>
                    <validation-provider #default="{ errors }" :name=" $t('employeeAddress.address')" rules="required">
                        <b-form-textarea id="employee-address-input" :placeholder=" $t('employeeAddress.address')" rows="3" v-model="addressInput" />
                        <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <label class="mt-2" for="employee-note-input">{{ $t('employeeAddress.note') }}</label>
                    <validation-provider #default="{ errors }" :name=" $t('employeeAddress.address')" rules="required">
                        <b-form-textarea id="employee-address-input" :placeholder=" $t('employeeAddress.note')" rows="3" v-model="note" />
                        <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                </b-col>
            </b-row>
        </validation-observer>
    </b-modal>
</div>
</template>

<script>
export default {
    props: {
        getEmployeeAddressList: {
            type: Function
        }
    },
    data() {
        return {
            addressTypeSelect: 0,
            addressTypeOption: [],
            addressInput: '',
            countrySelect: 0,
            countryOption: [],
            id: 0,
            employeeId: 0,
            note: '',
        }
    },
    methods: {
        showInfo(id, employeeId) {
            this.$refs['employeeAddressFormModal'].show()
            this.id = id
            this.employeeId = employeeId;
            if (this.employeeId == null) {
                this.employeeId = localStorage.getItem("EmployeeId")
            }
            const data = {
                id: this.id
            }
            const controller = {
                name: 'EmployeeAddress'
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$store.dispatch('moduleAuth/getInfo', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    this.addressInput = response.data.employeeAddress.address
                    this.note = response.data.employeeAddress.note
                    this.addressTypeOption = response.data.addressTypeList
                    this.addressTypeSelect = response.data.employeeAddress.addressTypeId
                    this.countryOption = response.data.countryList
                    this.countrySelect = response.data.employeeAddress.countryId
                    this.countryOption.splice(0, 0, this.$nullSelected())
                    this.addressTypeOption.splice(0, 0, this.$nullSelected())
                } else {
                    this.$bvModal.hide('employeeAddressFormModal')
                    this.$WarningAlert(response.data.resultMessage)
                }
            })
        },
        addOrUpdate() {
            if (this.employeeId == null) {
                this.employeeId = localStorage.getItem("EmployeeId")
            }
            const data = {
                id: this.id,
                employeeId: this.employeeId,
                address: this.addressInput,
                addressTypeId: this.addressTypeSelect,
                countryId: this.countrySelect,
                note: this.note
            }
            const controller = {
                name: 'EmployeeAddress'
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$refs.simpleRules.validate().then(success => {
                if (success) {
                    this.$store.dispatch('moduleAuth/save', payload).then((response) => {
                        if (response.data.resultStatus == true) {
                            this.$bvModal.hide('employeeAddressFormModal')
                            this.getEmployeeAddressList()
                            this.$SaveAlert()
                        } else {
                            this.$WarningAlert(response.data.resultMessage)
                        }
                    })
                }
            })
        },
    }
}
</script>

<style lang="scss">
[dir=ltr] .modal-header .close {
    margin: -0.4rem -0.4rem -0.8rem auto;
}

[dir] label {
    margin-bottom: 0.2857rem;
    font-weight: bold;
}

.modal .modal-content {
    overflow: visible;
    margin-bottom: auto;
}

[dir] .invalid-tooltip {
    padding: 0.4rem 0.775rem !important;
    margin-top: -1.5rem !important;
    background-color: #ea5455 !important;
    border-radius: 0.358rem !important;
    left: 20px !important
}
</style>
